import './styles.scss';

import * as React from 'react';
import Services, { ServiceProps } from './Services';

import { ResponsiveModalContainer } from '@weddingspot/ws-core-components';

export interface IProps {
    show: boolean;
    onClose: () => void;
    isPricedVenue: boolean;
    onCtaClick: () => void;
    ceremonies: ServiceProps[];
    receptions: ServiceProps[];
    rds: ServiceProps[];
    onClickInquire?: () => void;
    primaryCTAComponent: React.ReactElement<any>;
}

export default class ServiceOptionsModal extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.renderHeaderContent = this.renderHeaderContent.bind(this);
        this.renderFooterContent = this.renderFooterContent.bind(this);
    }

    renderHeaderContent() {
        return <div className='ServiceOptionsModal--headline'>Service options</div>;
    }

    renderFooterContent() {
        return <div className='ServiceOptionsModal--footer'>{this.props.primaryCTAComponent}</div>;
    }

    public render() {
        return (
            <div className='ServiceOptionsModal'>
                <ResponsiveModalContainer
                    show={this.props.show}
                    noFullscreen={true}
                    handleClickModalBackground={this.props.onClose}
                    handleClickModalClose={this.props.onClose}
                    headerContent={this.renderHeaderContent()}
                    footerContent={this.renderFooterContent()}
                >
                    <Services
                        ceremonies={this.props.ceremonies}
                        receptions={this.props.receptions}
                        rds={this.props.rds}
                        onClickInquire={this.props.onClickInquire}
                    />
                </ResponsiveModalContainer>
            </div>
        );
    }
}
